import React from 'react';
import { OneOffExportsCard } from './OneOffExportsCard';
import { RecurringExportsCard } from './RecurringExportsCard';

export function Exports() {
  return (
    <div className="RecurringExports content-margin">
      <OneOffExportsCard />
      <RecurringExportsCard />
    </div>
  );
}
